/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Tlm_2Inputs */

const en_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`failure_policy`)
};

const ar_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الفشل`)
};

const bn_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`failure_policy`)
};

const de_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fail_policy`)
};

const es_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`política_falla`)
};

const fr_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`échec_policy`)
};

const pt_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`política_de_falha`)
};

const zh_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`failure_policy`)
};

const tr_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`başarısızlık_politikası`)
};

const ru_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`отказ_политика`)
};

const pl_svc_automation_tlm_2 = /** @type {(inputs: Svc_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`polityka_awarii`)
};

/**
* | output |
* | --- |
* | "failure_policy" |
*
* @param {Svc_Automation_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_automation_tlm_2 = /** @type {((inputs?: Svc_Automation_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_tlm_2(inputs)
	if (locale === "bn") return bn_svc_automation_tlm_2(inputs)
	if (locale === "de") return de_svc_automation_tlm_2(inputs)
	if (locale === "es") return es_svc_automation_tlm_2(inputs)
	if (locale === "fr") return fr_svc_automation_tlm_2(inputs)
	if (locale === "pt") return pt_svc_automation_tlm_2(inputs)
	if (locale === "zh") return zh_svc_automation_tlm_2(inputs)
	if (locale === "tr") return tr_svc_automation_tlm_2(inputs)
	if (locale === "ru") return ru_svc_automation_tlm_2(inputs)
	if (locale === "pl") return pl_svc_automation_tlm_2(inputs)
	return en_svc_automation_tlm_2(inputs)
});